/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : APMSettingsInputGroup.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : APM  Settings Item Custom Text Group component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Jan 24, 2022
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Input } from "@scuf/common";
import { FieldError } from "react-hook-form";
import { APMSettingField } from "models/apmSettings";

interface IAPMSettingsInputProps {
  name: string;
  label: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  error?: FieldError;
  index: number;
  registerName: (item: number, apmFieldData: APMSettingField) => void;
  onChange: (item: string, value: string, index: number) => void;
  apmFieldValue: APMSettingField;
}

export const APMSettingsInputGroup: FC<IAPMSettingsInputProps> = ({
  name,
  label,
  value,
  registerName,
  index,
  disabled,
  error,
  apmFieldValue,
  onChange,
}) => {
  let addRequired = true;

  if (
    apmFieldValue?.type === 1 &&
    (apmFieldValue?.dataType === 3 ||
      apmFieldValue?.dataType === 4 ||
      apmFieldValue?.dataType === 7) &&
    parseInt(apmFieldValue?.minValue) === 0
  ) {
    addRequired = false;
  }

  const errorMessage = error ? error?.message : "";
  return (
    <>
      <Input
        label={label}
        name={name}
        indicator={addRequired ? "required" : undefined}
        data-testid={label}
        defaultValue={value}
        onChange={(changeValue) => onChange(name, changeValue, index)}
        ref={() => registerName(index, apmFieldValue)}
        disabled={disabled}
        error={errorMessage}
      />
    </>
  );
};
